var mySwiper = new Swiper(".mySwiper", {
  // Swiper parameters
  loop: true,
  spaceBetween: 25,
  slidesPerView: 3.5, // Adjust based on your design
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Responsive breakpoints
  breakpoints: {
    // when window width is <= 600px
    600: {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 10, // Adjust as needed
    },
    // when window width is >= 320px
    320: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3.5,
      spaceBetween: 15,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 3.5,
      spaceBetween: 15,
    },
  },
});

// Initialization for Button Block Swiper
var myButtonSwiper = new Swiper(".myButtonSwiper", {
  // Swiper parameters
  loop: true,
  spaceBetween: 25,
  slidesPerView: 3.5, // Adjust based on your design
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Responsive breakpoints
  breakpoints: {
    // when window width is <= 600px
    600: {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 10, // Adjust as needed
    },
    // when window width is >= 320px
    320: {
      slidesPerView: 6,
      spaceBetween: 10,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
});
